export const getKey = (id: any, values: any) => {
    return Object.keys(values).find((key) => key.includes(id));
};

const setFieldToDefaultForSchema = (schemaMatcher: any, fieldId: any, defaultValue: any, formResponseValues: any) => {
    if (formResponseValues[fieldId] === undefined && schemaMatcher) {
        formResponseValues[fieldId] = defaultValue;
    }
};

export const getValue = (id: any, values: any) => {
    const fieldName = Object.keys(values).find((key) => key.includes(id));
    // @ts-expect-error TS2538: Type 'undefined' cannot be used as an index type.
    return values[fieldName];
};

export const mutateFormValues = (values: any, definition: any, isPartnerAggsEdit: any) => {
    const formResponseValues = { ...values };

    const findElement = (item: any) => {
        return Object.keys(formResponseValues).find((element) => element.match(item));
    };

    if (isPartnerAggsEdit) {
        // @ts-expect-error TS2538: Type 'undefined' cannot be used as an index type.
        formResponseValues[findElement('marketing-permission')] = 'false';
        // @ts-expect-error TS2538: Type 'undefined' cannot be used as an index type.
        formResponseValues[findElement('future-soft-search-permission')] = 'false';
    }

    delete formResponseValues.preTaxIncomeDuration;
    delete formResponseValues.otherIncomeDuration;

    // `&` causes applications to get stuck in RAID - convert them to text prior to sending.
    if (getValue('occupation', values)) {
        const key = getKey('occupation', values);
        // @ts-expect-error TS2538: Type 'undefined' cannot be used as an index type.
        formResponseValues[key] = formResponseValues[key].replace(/&/g, 'and');
    }

    const isQco = definition.id.match(/qco/);

    // set other income amount to 0 if undefined for QCO schemas as question is optional on form
    // different for QCO as field is post-fixed with amount as the question is hidden behind a yes/no radio
    setFieldToDefaultForSchema(
        isQco,
        'income-03:other-household-income:other-household-income-amount',
        '0',
        formResponseValues
    );

    // set other income to 0 if undefined for other schemas as question is optional on form
    setFieldToDefaultForSchema(
        !isQco,
        'income-03:other-household-income:other-household-income',
        '0',
        formResponseValues
    );
    return formResponseValues;
};
